const resources = {
    beautyMatchesPopupText: 'A Beauty Match is someone who shares your Beauty Traits. For the best experience with this feature, please make sure you’ve added all your Beauty Traits in',
    beautyMatchesPopupLink: 'Community profile'
};

module.exports = function getResource(label) {
    return resources[label];
};
